
// TODO: We don't want a separate modal content for every case in the future.
// If not now, then next time we add a modal content we need to think of refactoring.
import Vue, { VueConstructor } from 'vue';
import { GoTos } from '@modules/husleie-framework/src/types/Modals.entity';
import BaseModal from '@modules/design-system/components/organisms/modals/BaseModal.vue';
import ButtonCloseModal from '@modules/design-system/components/atoms/buttons/ButtonCloseModal.vue';
import RedirectOperations from '@modules/husleie-framework/src/static-classes/RedirectOperations.class';
import ModalContent from '@modules/design-system/components/molecules/modals/ModalContent.vue';
import { AppRedirect } from '@modules/husleie-framework/src/enums/AppRedirect.enum';
import { mapGetters, mapMutations } from 'vuex';
export default (Vue as VueConstructor<Vue>).extend({
  name: 'o-modal',
  data() {
    return {
      showModal: false,
      showBackdrop: false,
    };
  },
  components: {
    'o-BaseModal': BaseModal,
    'a-ButtonCloseModal': ButtonCloseModal,
    'm-ModalContent': ModalContent,
  },
  computed: {
    ...mapGetters('common/staticData', ['getModalIsOpen', 'getModalName', 'getModalIsCloseable']),

    modal(): string | null {
      switch (this.getModalName) {
        default:
          return 'o-BaseModal';
      }
    },
    footer(): string {
      switch (this.getModalName) {
        default:
          return '';
      }
    },
  },

  methods: {
    ...mapMutations('common/staticData', ['openModal', 'closeModal']),
    backdropAfterEnter() {
      this.showModal = true;
    },
    slideAfterLeave() {
      this.showBackdrop = false;
      /**
       * @commonStoreOperations
       */
      this.closeModal();
    },
    close() {
      // TODO: Check AnimeJS or the other package i pasted in matrix.
      // Otherwise lets just do our own promise here instead of
      // timeouts.
      this.showModal = false;
    },
    goTo(where: string): void {
      // We need the promise returned here
      this.close();
      switch (where) {
        case GoTos.Dashboard:
          window.location.assign(RedirectOperations.getURL(AppRedirect.DASHBOARD_MYPAGE));
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.showBackdrop = true;
  },
});
